import omitBy from 'lodash/omitBy'
import isNull from 'lodash/isNull'
import type { Task } from 'paintscout'
import type { Owner } from '@paintscout/api'
import { uuid } from '../../util'

export function createTask(args: { task?: Partial<Task>; owner: Owner }): Task {
  const { task = {}, owner } = args
  const sanitized = omitBy(task, isNull)
  const now = task.startDateTime ? new Date(task.startDateTime) : new Date()
  const minutes = now.getMinutes()
  const nextHalfHour = minutes % 30 === 0 ? 0 : 30 - (minutes % 30)
  now.setMinutes(minutes + nextHalfHour)
  now.setSeconds(0)
  now.setMilliseconds(0)
  const roundedDate = now.valueOf()

  return {
    _id: uuid(),
    dealId: null,
    title: '',
    created: Date.now(),
    updated: null,
    completed: false,
    completedDate: null,
    notes: '',
    ...sanitized,
    owner: owner ? owner : null,
    startDateTime: roundedDate,
    type: 'task'
  }
}
